import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Route-level gate for admin pages; backend remains the real authority.
export default function RequirePermission({ perm, level = 'view', children }) {
  const { hasPermission } = useAuth();
  if (hasPermission(perm, level)) return children;
  return (
    <div className="p-6 max-w-xl mx-auto" data-testid="permission-denied">
      <div className="border rounded-lg p-6 bg-white text-center">
        <ShieldAlert className="w-8 h-8 mx-auto text-slate-400 mb-2" />
        <p className="font-medium text-slate-900">Sem permissão para acessar esta área.</p>
        <p className="text-sm text-slate-500 mt-1">Fale com um administrador se precisar de acesso.</p>
      </div>
    </div>
  );
}
